import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { AnimationStates } from '../animations/animation.constants';

@Injectable({ providedIn: 'root' })
export class ConsentService {
  private isPrevented = false;
  private readonly consentSheetSubject = new BehaviorSubject<string>(AnimationStates.closed);
  readonly onConsentSheetToggle$ = this.consentSheetSubject.asObservable();

  preventNextOpen(): void {
    this.isPrevented = true;
  }

  open(): void {
    setTimeout(() => {
      if (!this.isPrevented) {
        document.body.classList.add('sheet--open');
        this.consentSheetSubject.next(AnimationStates.open);
      }

      this.isPrevented = false;
    }, 2000);
  }

  close(): void {
    document.body.classList.remove('sheet--open');
    this.consentSheetSubject.next(AnimationStates.closed);
  }
}
